import {useConfigContext} from "../ConfigContext";
import React, {useEffect} from "react";
import BtnModal from "../../../components/atoms/BtnModal";
import Modal from "../../../components/atoms/Modal";
import Title from "../../../components/atoms/Title";

const AcceptUpdateModal = () => {
    const {closeModal, modalState, updateApplicationVersion} = useConfigContext()

    const isOpen = modalState.isOpen && modalState.mode === "update";

    if (!isOpen) {
        return null;
    }

    return (

        <Modal title={"تایید اپدیت"} closeModal={closeModal}>
            <div className="flex flex-col gap-4 mb-5 w-[300px] h-[100px]">
                <p className={"font-medium"}>آیا آپدیت اپلیکشن با تنظیمات زیر را تایید میکنید؟</p>
                <span>
                    <span>
                        ورژن وارد شده
                    </span>
                    <span> </span>
                     <span className={"font-medium"}>
                       {modalState.selectedItem.version}
                    </span>

                </span>

                <span>
                    <span>
                        این آپدیت
                    </span>
                    <span> </span>
                    <span className={"font-medium"}>
                       {modalState.selectedItem.isForce ? "ضرروی" : "عادی"}

                    </span>
                    <span> </span>
                    <span>
                        است
                    </span>
                </span>

            </div>

            <div className="flex flex-row items-center gap-2 justify-end pt-5.5">
                <BtnModal
                    text={"تایید"}
                    accept={() => {
                        updateApplicationVersion(modalState.selectedItem)
                    }}
                    disabled={false}
                />


            </div>

        </Modal>

    )
}
export default AcceptUpdateModal;